// @flow
import { getCookie } from 'angieslist-app-platform/lib/common/utils/cookieUtils';
import queryString from 'query-string';
import { get } from 'lodash';
import { defaultProps } from './analyticsDefaultProperties';

export type itemClickedType = {
  activityLocation: string,
  description?: string,
  otherProps?: Object
}

export const itemClicked = (activityLocation: string, description?: string = '<<attributes.data-track-description.value>>', otherProps?: Object = {}): Object => ({
  click: {
    name: 'Item Clicked',
    properties: {
      description,
      activityLocation,
      ...defaultProps,
      ...otherProps,
    },
  },
});

export const itemFocused = (activityLocation: string, description?: string = '<<attributes.data-track-description.value>>', otherProps?: Object = {}): Object => ({
  focus: {
    name: 'Item Clicked',
    properties: {
      description,
      activityLocation,
      ...defaultProps,
      ...otherProps,
    },
  },
});

export const trackEvent = (name: string, activityLocation: string, description?: string = '<<attributes.data-track-description.value>>', otherProps?: Object = {}): {|click: {|name: string, properties: any|}|} => ({
  click: {
    name,
    properties: {
      description,
      activityLocation,
      ...defaultProps,
      ...otherProps,
    },
  },
});

export function getCampaign(key: string): ?string {
  if (process.env.IS_BROWSER) {
    return get(queryString.parse(window.location.search), key) || getCookie(key);
  }
  return undefined;
}

export const getCid = (): ?string => getCampaign('cid');



// WEBPACK FOOTER //
// ./src/app/browser/analyticsHelpers.js